<template>
  <li 
    v-if="department"
    class="side-members__content"
    style="cursor: pointer;">
    <div
      class="side-members__link p-3">
      <p>
        <span class="material-icons side-members__icon mr-1">
          people
        </span>
        {{ department.name }}
      </p>
      <slot name="pin-icon" />
    </div>
    <transition name="list-menu">
      <div
        v-if="showMembers"
        @click.stop>
        <ul
          class="side-members__list list-unstyled">
          <slot />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {
    department: {
      type: Object,
      default: null
    },
    showMembers: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped>
.list-menu-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-menu-leave-active {
  transition: all 0.1s;
}
.list-menu-enter, .list-menu-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>

<style lang="scss" scoped>
.side-members {
  &__link{
    text-decoration: none;
    color: $white;
    font-weight: bold;
    display: flex;
    background-color: $l-blue;
    justify-content: space-between;
    &:hover{
      text-decoration: none;
      color: $white;
      background-color: lighten($l-blue, 5%);
    }

    .pin-icon-button {
      width: 18px;
      height: 18px;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;

      .pin-icon {
        width: 12px;
        height: 12px;
      }
    }
  }
  &__icon{
    color: $white;
    vertical-align: middle;
  }
  &__item {
    &__chart-icon {
      color: $grey03;
    }
  }
}
</style>